import { render } from "./PuxTaskLogProgress.pug?vue&type=template&id=924eb618&lang=pug"
import script from "./PuxTaskLogProgress.js?vue&type=script&lang=js"
export * from "./PuxTaskLogProgress.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__